import PageNotFoundDataRoom from './PageNotFoundDataRoom.page';

export default PageNotFoundDataRoom;